import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { ConfirmModalComponent } from "./confirm-modal/confirm-modal.component";
import { TranslatePipe, TranslateDirective } from "@ngx-translate/core";
import { LoadingComponent } from './loading/loading.component';
import { ModalComponent } from './modal/modal.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { EmailComponent } from "./email/email.component";
import { Button, Header, HeaderTitle, Main, Wrap } from "../../components";
import { AutofocusDirectiveModule } from "./autofocus/autofocus.module";
import { MessageModalComponent } from "./message-modal/message-modal.component";

@NgModule({
  declarations: [
    LoadingComponent,
    ModalComponent,
    DropdownComponent,
    ConfirmModalComponent,
    MessageModalComponent,
    EmailComponent
  ],
  imports: [
    AutofocusDirectiveModule,
    CommonModule,
    FormsModule,
    TranslatePipe,
    TranslateDirective,
    RouterModule,
    Button,
    Header,
    HeaderTitle,
    Main,
    Wrap
  ],
  exports: [
    AutofocusDirectiveModule,
    FormsModule,
    TranslatePipe,
    TranslateDirective,
    LoadingComponent,
    ModalComponent,
    RouterModule,
    DropdownComponent,
    ConfirmModalComponent,
    EmailComponent,
    Button,
    Header,
    HeaderTitle,
    Main,
    Wrap
  ]
})
export class SharedModule {
}
